import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import { WorkerPool } from "types/generated";
import useCanResetWorkerPool from "shared/WorkerPool/access/useCanResetWorkerPool";

type WorkerPoolResetActionProps = {
  onAction: () => void;
  workerPool: WorkerPool;
};

const WorkerPoolResetAction = ({ onAction, workerPool }: WorkerPoolResetActionProps) => {
  const managedByK8sController = workerPool.managedByK8sController;
  const canResetWorkerPool = useCanResetWorkerPool()(workerPool);
  const hasBusyWorkers = workerPool.busyWorkers > 0;

  const getTooltip = () => {
    if (managedByK8sController) {
      return "The credentials cannot be reset because this pool is managed via the Kubernetes controller.";
    }
    if (!canResetWorkerPool.result) {
      return canResetWorkerPool.message;
    }
    if (hasBusyWorkers) {
      return (
        <>
          Please drain all workers first to make sure that no work is being performed by this worker
          pool.
          <br />
          <br />
          Resetting this worker pool means that existing workers can no longer be used and will need
          to be restarted with the new configuration.
        </>
      );
    }
    return (
      <>
        Resetting this worker pool means that existing workers can no longer be used and will need
        to be restarted with the new configuration.
      </>
    );
  };

  const isDisabled = !canResetWorkerPool.result || hasBusyWorkers || managedByK8sController;
  const tooltip = getTooltip();

  return (
    <DropdownMenuItem
      tooltipWidthMode="maxWidthSm"
      tooltipPlacement="left"
      tooltip={tooltip}
      onAction={onAction}
      isDisabled={isDisabled}
    >
      Reset
    </DropdownMenuItem>
  );
};

export default WorkerPoolResetAction;
